import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { jwtDecode } from "jwt-decode";
import api from "../../../../api/axiosInstance";
export const loginFunc = createAsyncThunk(
  "login",
  async ({ data }, thunkAPI) => {
    try {
      const response = await api.post(`dashboard/login`, data);
      if (response.data.success === true) {
        const token = response.data.data.authorisation.token;
        const decodeToken = jwtDecode(response.data.data.authorisation.token);
        localStorage.setItem("expire_date", decodeToken.exp);
        localStorage.setItem("token", token);
        const user = {
          id: response.data.data.user.id,
          name: response.data.data.user.name,
          email: response.data.data.user.email,
          phone: response.data.data.user.phone,
          image: response.data.data.user.image_url,
          roleName:
            response.data.data.user.roles &&
            response.data.data.user.roles[0].name,
          // assistantTeacherId : response.data.data.user.user_id && response.data.data.user.user_id,
          permissions:
            response.data.data.user.roles[0].permissions &&
            response.data.data.user.roles[0].permissions,
        };
        localStorage.setItem("user", JSON.stringify(user));
        return response.data;
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

const loginSlicer = createSlice({
  name: "user login",
  initialState: {
    loading: false,
    status: null,
    error: false,
  },
  reducers: {
    loginAction: (state, action) => {
      state.loading = false;
      state.status = "loggedIn";
      state.error = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(loginFunc.pending, (state) => {
      state.loading = true;
      state.status = null;
      state.error = false;
    });
    builder.addCase(loginFunc.rejected, (state) => {
      state.loading = false;
      state.status = null;
      state.error = true;
    });
    builder.addCase(loginFunc.fulfilled, (state, action) => {
      state.loading = false;
      state.status = action.payload;
      state.error = false;
    });
  },
});
export default loginSlicer.reducer;
export let { loginAction } = loginSlicer.actions;
